<template>
  <div id="contact" class="page">
      <ContentHeader header-title="Contact"/>
      <p>Heb je een vraag over onze radio en tvprogramma’s, of over deze website 
      neem dan contact op via e-mail door middel van onderstaand formulier of stuur zelf een mailtje naar: <span class="orange">info@RTVParkstad.nl</span></p>
      <h3>Contact met de radiostudio:</h3>
      <p>Bel rechtstreeks met de DJ in de studio op <strong>045 5610 610</strong> of stuur een appje.</p>
      <h3>Contact met de TV-redactie:</h3>
      <p>Stuur je mail voor onze televisieredactie naar <span class="orange">tv@RTVParkstad.nl</span></p>
      <h3>Adverteren:</h3>
      <p>Voor contact over adverteren, ga naar het kopje "Adverteren" in ons menu!</p>
      <h3>Mail een RTVP DJ:</h3>
      <p>Je mailtje kan naar “voornaam@RTVParkstad.nl” (bijvoorbeeld roger@rtvparkstad.nl)</p>
      <h3>Bezoekadres:</h3>
      <p>Stenen Brug 13a, 6372AP Landgraaf</p>
  </div>
</template>

<script>
import ContentHeader from "@/components/ContentHeader.vue";

export default {
  name: "Contact",
  components: {
    ContentHeader
  },
}
</script>

<style lang="scss">
#contact {
  margin: auto;
  max-width: 768px;

 h3 {
    font-family: "Lato";
    color: #ffae32;
    font-weight: bold;
    margin-bottom: 15px;  
    }

  p {
    font-family: "Lato";
    font-size: 14px;
    margin-bottom: 16px;

    .orange {
      color: #FF5000;
    }

  }
}

/* Smartphones (portrait and landscape) ----------- */

@media only screen and (min-device-width: 320px) and (max-device-width: 599px) {
    #contact {
      margin: 16px 16px;
    }
}

/* Tablet (portrait) ----------- */

@media only screen and (min-device-width: 600px) and (max-device-width: 899px) {
    #contact {
      margin: 16px 16px;
    }
}

/* Tablet (landscape) ----------- */

@media only screen and (min-device-width: 900px) and (max-device-width: 1199px)  {
    #contact {
        margin: 16px 16px;
    }
}

// Desktop versions start here ------------------------------------------------------------------------------------------
/* Desktop ----------- */

@media only screen and (min-device-width: 1200px) and (max-device-width: 1799px)  {
    #contact {
      margin-top: 160px;
      margin-bottom: 100px;
    }
}

/* Large desktop ----------- */

@media only screen and (min-device-width: 1800px)  {
    #contact {
      margin-top: 160px;
      margin-bottom: 100px;
    }
}
</style>